import React from 'react';
import Cta from './call_to_action';
import LogoList from './logo_list';

const BlockRenderer = ({ block }) => {
  if (!block || block.length === 0) {
    return null;
  }

  const isQlData = block[0]?.__typename ? true : false;

  return block.map((blockItem, index) => {
    const blockType = isQlData
      ? Object.keys(blockItem)[1]
      : Object.keys(blockItem)[0];

    switch (blockType) {
      case 'cta':
        return <Cta key={`section-${index}`} data={blockItem} />;
      case 'logo_list_horizontal':
        return (
          <LogoList
            key={`section-${index}`}
            data={blockItem}
            isQlData={isQlData}
            index={index}
          />
        );
      default:
        return null;
    }
  });
};

export default BlockRenderer;
